/* unplugin-vue-components disabled */import script from "./AnchorHintHost.vue?vue&type=script&setup=true&lang=js"
export * from "./AnchorHintHost.vue?vue&type=script&setup=true&lang=js"

import "./AnchorHintHost.vue?vue&type=style&index=0&id=42db2160&lang=scss&scoped=true"

import exportComponent from "../../../../../../Users/mac/myproject/deepsage/deepsage_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42db2160"]])

export default __exports__